import * as React from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useInterceptor } from "@stemscopes/api";
import { ErrorBoundary } from "components";
import { useAuth } from "hooks";
import { useNavigate } from "react-router-dom";
import { Theme } from "types";
import { appOperations } from "./duck";
import { AppContext } from "./duck/context";
import App from "./App";

const AppProvider: React.FC = () => {
  const navigate = useNavigate();
  const [, setAuth] = useAuth();
  const [theme, setTheme] = React.useState<Theme>("default");
  const [pin, setPin] = React.useState<string>("");
  const [errorPage, setErrorPage] = React.useState<boolean>(false);

  useInterceptor("request", appOperations.prepareRequest);

  useInterceptor("response", appOperations.prepareSuccess, (error) =>
    appOperations.prepareFailure({ error, navigate, setAuth }),
  );

  return (
    <AppContext
      value={{ theme, setTheme, pin, setPin, errorPage, setErrorPage }}
    >
      <ErrorBoundary>
        <DndProvider backend={HTML5Backend}>
          <App />
        </DndProvider>
      </ErrorBoundary>
    </AppContext>
  );
};

export default AppProvider;
